export function matchesConnectorQuery(name: string, slug: string, q: string): boolean {
  const n = name.toLowerCase();
  const s = slug.toLowerCase();
  if (q.length === 1) return s.startsWith(q) || n.split(/\s+/).some((word) => word.startsWith(q));
  return n.includes(q) || s.includes(q);
}

export function matchesMcpQuery(name: string, url: string | undefined, q: string): boolean {
  return name.toLowerCase().includes(q) || (url ?? '').toLowerCase().includes(q);
}
